// extracted by mini-css-extract-plugin
export default {"banner":"iv4IGM4wry25vst4W_rs"};